var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 109,
    viewBox: "0 0 133 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 88.4268C83.6 88.4268 98 74.0268 98 56.4268C98 38.8268 83.6 24.4268 66 24.4268C48.4 24.4268 34 38.8268 34 56.4268C34 74.0268 48.4 88.4268 66 88.4268Z",
    fill: "#2EB67D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4004 56.4271L61.4564 65.4831L79.6004 47.3711",
    fill: "#2EB67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4004 56.4271L61.4564 65.4831L79.6004 47.3711",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.403 30.6104C107.403 30.6104 105.62 22.1172 109.869 19.7608C114.205 17.3569 118.826 21.2689 123.007 18.5878C127.337 15.8108 125.828 5.30189 125.828 5.30189",
    stroke: "#F15845",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 45.9268,
    r: 5.5,
    fill: "#0080FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 35.9268,
    r: 5.5,
    fill: "#ECB22E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111 68.4266C111 68.4266 118.799 62.0178 123.857 65.4268C127.758 68.0558 131 75.4266 131 75.4266",
    stroke: "#ECB22E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 63.4279C2 63.4279 9.79858 69.8367 14.8571 66.4277C18.7583 63.7987 22 56.4279 22 56.4279",
    stroke: "#F15845",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.528,
    cy: 101.17,
    r: 5.5,
    transform: "rotate(-43.1563 101.528 101.17)",
    fill: "#0080FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 85.9268,
    r: 5.5,
    fill: "#0080FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 5.92676,
    r: 5.5,
    fill: "#0080FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.9377,
    cy: 92.5701,
    r: 3,
    transform: "rotate(-43.1563 85.9377 92.5701)",
    fill: "#ECB22E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 14.4268,
    r: 3,
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.b6d8e9be57ea9ff7189ab453e2115667.svg";
export { ForwardRef as ReactComponent };